import { render, staticRenderFns } from "./AddTaskItem.vue?vue&type=template&id=5fbf7e87&scoped=true"
import script from "./AddTaskItem.vue?vue&type=script&lang=js"
export * from "./AddTaskItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbf7e87",
  null
  
)

export default component.exports